import React from 'react';

import {
  DescriptionItem,
  DescriptionList,
  Link,
  Paper,
  Typography,
} from '@gogame/components';

import { CampaignDetails } from 'scenes/Campaigns/GGCampaigns/components/CampaignDetails';
import AffiliateDetails from 'scenes/Affiliates/components/AffiliateDetails';

export default ({ data, openChildComponent }) => {
  const handleOpenRegistrationCampaign = () => {
    openChildComponent(CampaignDetails, {
      id: data.playerInformation.registrationCampaign.id,
    });
  };
  const handleOpenAffiliate = () => {
    openChildComponent(AffiliateDetails, {
      id: data.playerInformation.registrationAffiliate.id,
    });
  };

  return {
    color: 'success',
    date: data.playerInformation.registrationDate,
    title: (
      <Typography>
        {data.playerInformation?.registrationCampaign?.id ? (
          <React.Fragment>
            <span>Registration - </span>
            <Link onClick={handleOpenRegistrationCampaign}>
              {data.playerInformation.registrationCampaign.name}
            </Link>
          </React.Fragment>
        ) : (
          <span>Organic</span>
        )}
        <span> ({data.playerInformation.registrationCampaign.owner})</span>
      </Typography>
    ),
    content: (
      <Paper
        sx={{ padding: 2, marginTop: 1, width: '100%' }}
        variant={'outlined'}
        elevation={0}
      >
        <DescriptionList
          termWidth={'200px'}
          data={data.playerInformation}
          disableGutters={true}
          stripEmpty={true}
        >
          <DescriptionItem
            label={'Campaign ID'}
            field={'registrationCampaign.id'}
          />
          {data?.playerInformation?.registrationAffiliate?.id ? (
            <DescriptionItem
              label={'Affiliate Name'}
              field={'registrationAffiliate'}
              type={'link'}
              linkLabelField={'name'}
              onValueClick={handleOpenAffiliate}
            />
          ) : (
            <DescriptionItem
              label={'Affiliate Name'}
              field={'registrationAffiliate.name'}
            />
          )}

          <DescriptionItem
            label={'Affiliate ID'}
            field={'registrationAffiliate.id'}
          />
          <DescriptionItem
            label={'Publisher'}
            field={'publisher'}
            placeholder={'—'}
          />
          <DescriptionItem label={'Country'} field={'registrationCountry'} />
          <DescriptionItem label={'Platform'} field={'registrationPlatform'} />
          <DescriptionItem label={'OS'} field={'registrationOs'} />
          <DescriptionItem
            label={'Device type'}
            field={'registrationDeviceType'}
          />
        </DescriptionList>
      </Paper>
    ),
  };
};
